import {
    useState,
    useRef,
    useCallback,
    useEffect,
    useLayoutEffect,
} from "react";
import { Button, Tabs, Tab } from "react-bootstrap";
import { ArrowLeft, RotateCcw, Send } from "react-feather";
import { useNavigate } from "react-router-dom";
import DrawSignature from "./tabs/DrawSignature";
import UploadSignature from "./tabs/UploadSignature";
import SelectSignature from "./tabs/SelectSignature";
import getSignature, { getStudentSignatures } from "./hooks/getSignature";
import Loader2 from "../../../../components/Loader2";

export default function Signature({ onSubmit, studentId, loadingSignatures, additionalPayloadData}) {
    const [signatures, setSignatures] = useState(null);
    const [selectedSignature, setselectedSignature] = useState(null);

    useLayoutEffect(() => {
        async function fetchSignatures() {
            try {
                const response = await getStudentSignatures({ studentId });
                setSignatures(response.data); // depends on your API
            } catch (err) {
                console.error("Failed to fetch signatures", err);
            }
        }

        fetchSignatures();
    }, [studentId, loadingSignatures]);

    const [key, setKey] = useState("draw");
    const navigate = useNavigate();
    const canvasRef = useRef(null);

    const [upload, setUpload] = useState([]);

    const handleChangeFile = useCallback(
        (e) => {
            setUpload(e);
        },
        [setUpload]
    );


    useEffect(() => {
        handleClear();
    }, [key]);
    


    const handleClear = () => {
        canvasRef.current?.clear();
        setUpload([]);
        setselectedSignature([]);
    };

    const payloadHandlers = {
        draw: () => {
            if (canvasRef.current?.isEmpty()) {
                alert("Please provide a signature first.");
                return null;
            }
            return { type: "draw", data: canvasRef.current.toDataURL() };
        },
        upload: () => {
            if (!upload.length) {
                alert("Please upload at least one file.");
                return null;
            }
            return { type: "upload", files: upload };
        },
        selection: () =>{
            if(!selectedSignature){
                alert("Please select a signature.");
                return null;
            }
            return { type: "selection", id: selectedSignature };
        }
    };

    const handleSave = () => {
        const handler = payloadHandlers[key];
        if (!handler) {
            console.warn(`No handler defined for type "${key}"`);
            return;
        }
        const payload = handler();
        if (!payload) return;
        console.log('additional payload', additionalPayloadData);
        // Added the additionalPayload data that is optional so you can pass additional data to the signature data
        onSubmit?.({ ...payload, signatures, ...(additionalPayloadData && {additionalPayloadData}) });
        handleClear();
        console.log('cleared');
    };

    return (
        <div>
            {loadingSignatures ? (
                <Loader2 />
            ) : (
                <Tabs
                    id="signature-tabs"
                    activeKey={key}
                    onSelect={setKey}
                    className="mb-3 custom-tabs"
                >
                    <Tab eventKey="draw" title="Draw">
                        <DrawSignature canvasRef={canvasRef} />
                    </Tab>
                    <Tab eventKey="upload" title="Upload">
                        <UploadSignature setFiles={handleChangeFile} />
                    </Tab>
                    <Tab eventKey="selection" title="Select">
                        <SelectSignature 
                            signatures={signatures?.signatures}      // pass fetched data
                            onSelect={setselectedSignature}
                            activeTab={key}
                        />
                    </Tab>
                </Tabs>
            )}

            <div className="mt-3 d-flex justify-content-end w-100 gap-3 ">
                <Button
                    variant="outline-secondary"
                    className="rounded-3"
                    onClick={() => navigate(-1)}
                    disabled={loadingSignatures}

                >
                    <ArrowLeft size={16} className="me-2 mb-1" /> Cancel
                </Button>

                {key === "draw" && (
                    <Button
                        variant="outline-secondary"
                        onClick={handleClear}
                        className="rounded-3"
                        disabled={loadingSignatures}

                    >
                        <RotateCcw size={16} className="me-2 mb-1" /> Clear
                    </Button>
                )}

                <Button
                    variant="primary"
                    onClick={handleSave}
                    className="rounded-3"
                    disabled={loadingSignatures}

                >
                    <Send size={16} className="me-2 mb-1" /> Submit
                </Button>
            </div>

            <style jsx>{`
                .custom-tabs .nav-link {
                    border-radius: 0 !important;
                    background-color: transparent;
                    border: none;
                    border-bottom: 2px solid transparent;
                    color: #000;
                    font-weight: 500;
                    margin-right: 0.5rem;
                }
                .custom-tabs .nav-link.active {
                    border-bottom: 2px solid #0d6efd;
                    color: #0d6efd;
                    background-color: transparent;
                }
            `}</style>
        </div>
    );
}
